<template>
  <div id="webinarList">
    <div class="pc description">
      <h3 class="description__title">{{type === 'KEE'?'Keysight Engineering Education':'Keysight Talks Standards'}}</h3>
      <div class="description__content" v-show="type === 'KEE'">
        <div class="primary">所有活动免费，时间：下午3点-5点（北京时间），地点：线上直播和KEE微信群</div>
        <div>勾选一个或多个课程主题，然后点击“报名参会”按钮，方可报名。<br>会前我们会邮件或短信提醒您参会</div>
      </div>
      <div class="description__content" v-show="type === 'KTS'">
        <div class="primary">所有活动免费，时间：下午3点-4点（北京时间），地点：线上直播和KTS微信群</div>
        <img src="../assets/kts/ktsImg.jpg"/>
        <div class="label">“是德科技大讲堂——谈标准”, 简称KTS：定期邀请来自各个标准机构的专家以及是德科技的行业标准专家齐聚一堂，共同<strong>探讨电子行业中通信和网络标准的最新动态和未来发展</strong>。</div>
        <div class="label">是德科技大讲堂采用了<strong>全新的形式</strong>。每期大讲堂都会有演讲者（通过网络摄像头录制的视频）讨论一种标准。大讲堂时长不超过 30 分钟，演讲者<strong>采用对话的语气开展讨论</strong>。</div>
        <div class="label">每次大讲堂前，注册报名观众可根据当期大讲堂主题在<strong>提问区提交问题</strong>, 活动当天是德科技专家会<strong>现场回答提交的问题</strong>。被选中现场回答问题的参与者将会获得一份<strong>精美礼品</strong>一份。</div>
        <div class="label">本系列大讲堂的<strong>内容涵盖 5G、汽车、数据中心等行业标准</strong>。 </div>
      </div>
    </div>
    <div class="pc tabBar">
      <div v-for='(category, categoryIndex) in categories' :key="category.id" class="nav">
        <div class='mutil-query-title' :class="{'mutil-query-title-sub': category.name === '课程主题'}" v-if='category.name' :key="category.id">{{category.name}}</div>
        <ol v-if='category.children.length'>
          <li v-for='(item,key) in category.children'>
            <span :class="{'active':item.active}" @click='handleCategory(categoryIndex,key,item.name)' :key='item.id'>{{item.name}}</span>
          </li>
        </ol>
      </div>
    </div>
    <div class="pc webinarCon">
      <div class="submitAll" @click="submitAll()" v-if="webinarShow && LoginStatus === 1" :class="{Hide:afterChangeData1.length === 0}">全选</div>
      <div class="signUp" @click="submitFun()">报名参会</div>
      <!--<div class="webinarList" :class="{active:currentYear === 2020}">-->
      <div class="webinarList" :class="{active:(afterChangeData1.length > 0 ||afterChangeData2.length>0 )}">
        <div class="trailNoticeCon" v-if="webinarShow" :class="{Hide:afterChangeData1.length === 0}">
          <div class="title"><img src="../assets/CoursePreview.png" alt="课程预告"></div>
          <ul class="list">
            <li v-for="(item, index) of afterChangeData1" :key="item.id" :class="{bgactive: index === current2020}">
              <div v-bind:class="{inputhide: LoginStatus === 0}" class="wap-div">
                <input type="checkbox"
                       :id="'trailNotice2020'+index"
                       :checked="item.subselected"
                       name="trailNotice"/>
                <label :for="'trailNotice2020'+index"
                       :class="{selectd: item.selectedStatus}"
                       @click="subselect(item, $event)">
                </label>
              </div>
              <div :class="{redclass: LoginStatus === 1 ,liactive: index === current2020}"
                   class="traildot traildiv wap-div"
                   @click="clickAircle(item); addClassFun(index)">
                <span v-if="item.keePhase.value">{{item.keePhase.value}}:</span>
                <span>{{item.newStartTime}}&nbsp;&nbsp;&nbsp;{{item.title}}</span>
                <span :class="{Block: item.Todynum === 1}" class="todydots todyradio"></span>
                <span :class="{Block: item.Todynum === 2}" class="todydots todyradio2"></span>
              </div>
              <img v-bind:class="{arrowsimg: index === current2020}" src="../assets/arrows.png" alt=""/>
            </li>
          </ul>
          <el-pagination
              background
              prev-text="上一页"
              next-text="下一页"
              :current-page.sync="currentPage1"
              :page-size="pageSize"
              :total="foreShow1.length"
              layout="prev, pager, next"
              style="text-align:center;"
              @current-change="handleCurrentChange"
          />
        </div>
        <div class="playbackCon" v-if="demindShow" :class="{Hide:afterChangeData2.length === 0}">
          <div class="title"><img src="../assets/WatchPlayback.png" alt="观看回放"></div>
          <ul class="list">
            <li v-for="(item, index) of afterChangeData2" :key="item.id"
                @click="addaudioClas(index), clickAircle(item)"
                :class="{liactive:index ===radiocurrent2020}">
              <div class="traildot traildiv wap-div">
                <span v-if="item.keePhase.value">{{item.keePhase.value}}:&nbsp;&nbsp;{{item.newStartTime}}&nbsp;&nbsp;&nbsp;{{item.title}}</span>
                <!--<span>{{item.newStartTime}}&nbsp;&nbsp;&nbsp;{{item.title}}</span>-->
              </div>
              <img v-bind:class="{arrowsimg:index === radiocurrent2020}" src="../assets/arrows.png" alt=""/>
            </li>
          </ul>
          <el-pagination
              prev-text="上一页"
              next-text="下一页"
              background
              :current-page.sync="currentPage2"
              :page-size="pageSize"
              :total="foreShow2.length"
              layout="prev, pager, next"
              style="text-align:center;"
              @current-change="handleCurrentChange2"
          />
        </div>
      </div>
    </div>
    <div class="Wap description">
      <h3 class="description__title">{{type === 'KEE'?'Keysight Engineering Education':'Keysight Talks Standards'}}</h3>
      <div class="description__content" v-show="type === 'KEE'">
        <div class="primary">所有活动免费，时间：下午3点-5点（北京时间），地点：线上直播和KEE微信群</div>
        <div>勾选一个或多个课程主题，然后点击“报名参会”按钮，方可报名。<br>会前我们会邮件或短信提醒您参会</div>
      </div>
      <div class="description__content" v-show="type === 'KTS'">
        <div class="primary">所有活动免费，时间：下午3点-4点（北京时间），地点：线上直播和KTS微信群</div>
        <img src="../assets/kts/ktsImg.jpg"/>
        <div class="label">“是德科技大讲堂——谈标准”, 简称KTS：定期邀请来自各个标准机构的专家以及是德科技的行业标准专家齐聚一堂，共同<strong>探讨电子行业中通信和网络标准的最新动态和未来发展</strong>。</div>
        <div class="label">是德科技大讲堂采用了<strong>全新的形式</strong>。每期大讲堂都会有演讲者（通过网络摄像头录制的视频）讨论一种标准。大讲堂时长不超过 30 分钟，演讲者<strong>采用对话的语气开展讨论</strong>。</div>
        <div class="label">每次大讲堂前，注册报名观众可根据当期大讲堂主题在<strong>提问区提交问题</strong>, 活动当天是德科技专家会<strong>现场回答提交的问题</strong>。被选中现场回答问题的参与者将会获得一份<strong>精美礼品</strong>一份。</div>
        <div class="label">本系列大讲堂的<strong>内容涵盖 5G、汽车、数据中心等行业标准</strong>。 </div>
      </div>
    </div>
    <login class="Wap" v-if="isWap" />
    <div class="Wap tabBar">
      <div class="pick-con">
        <div class="tablist">
          <ol class="sort-ol">
            <li class="tk" v-for="(v,index) in categories" :class="{cur:v.active}" @click="changeTab(index)">
              <span class="tt" v-cloak ref="chooseName">{{v.name}}</span>
              <i class="i"></i>
            </li>
          </ol>
        </div>
        <div class="droplist" >
          <ul class="sort-ul" v-for="(v,categoryIndex) in categories" :key="v.name"  v-show="v.isShow">
            <li class="tg" v-for="(c,index) in v.children" :key="c.name" :class="{cur:c.active}" @click="handleCategory(categoryIndex,index,c.name)">
              <span class="ti" v-cloak>{{c.name}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="Wap webinarCon">
      <div class="submitAll" @click="submitAll()" v-if="LoginStatus === 1" :class="{Hide:afterChangeData1.length === 0}">全选</div>
      <div class="signUp" @click="submitFun()">报名参会</div>
      <div class="webinarList" :class="{active:currentYear === 2020}">
        <div class="trailNoticeCon" v-if="webinarShow" :class="{Hide:afterChangeData1.length === 0}">
          <div class="title"><img src="../assets/CoursePreview.png" alt="课程预告"></div>
          <ul class="list">
            <li v-for="(item, index) of afterChangeData1" :key="item.id"
                v-bind:class="{liactive: wapOpenArr.indexOf(item.instanceId) !== -1}">
              <div v-bind:class="{inputhide: LoginStatus === 0}" class="wap-div">
                <input type="checkbox" :id="'trailNotice2020wap'+index" :checked="item.subselected" name="trailNotice"/>
                <label :for="'trailNotice2020wap'+index"
                       :class="{selectd: item.selectedStatus}"
                       @click="subselect(item, $event)">
                </label>
              </div>
              <div :class="{redclass: LoginStatus === 1, traildiv :LoginStatus === 1}"
                   class="traildot  wap-div"
                   @click="addClassFun(index),clickAircle(item)">
                <span v-if="item.keePhase.value">{{item.keePhase.value}}:</span>
                <span>{{item.newStartTime}}&nbsp;&nbsp;&nbsp;{{item.title}}</span>
                <span :class="{Block: item.Todynum === 1}" class="todydots todyradio"></span>
                <span :class="{Block: item.Todynum === 2}" class="todydots todyradio2"></span>
              </div>
              <img :class="{arrowsimg: wapOpenArr.indexOf(item.instanceId) === -1}"
                   @click="addClassFun(index), clickAircle(item)"
                   src="../assets/close.png"/>
              <img v-bind:class="{arrowsimg: wapOpenArr.indexOf(item.instanceId) !== -1}"
                   @click="addClassFun(index), clickAircle(item)"
                   src="../assets/open.png"
                   alt=""/>
              <div class="clear"></div>
              <webinar-details :item-info="item" v-if="wapOpenArr.indexOf(item.instanceId) !== -1" class="detailshow"/>

            </li>
          </ul>
          <el-pagination
              prev-text="上一页"
              next-text="下一页"
              background
              :current-page.sync="currentPage1"
              :page-size="pageSize"
              :total="foreShow1.length"
              layout=" prev, pager, next"
              style="text-align:center;"
              @current-change="handleCurrentChange"
          />
        </div>
        <div class="playbackCon" v-if="demindShow" :class="{Hide:afterChangeData2.length === 0}">
          <div class="title"><img src="../assets/WatchPlayback.png" alt="观看回放"></div>
          <ul class="list">
            <li v-for="(item, index) of afterChangeData2" :key="item.id"
                v-bind:class="{liactive: wapOpenArr.indexOf(item.instanceId) !== -1}">
              <div class="traildot wap-div"
                   @click="addaudioClas(index), clickAircle(item)">
                <span v-if="item.keePhase.value">{{item.keePhase.value}}:</span>
                <span>{{item.newStartTime}}&nbsp;&nbsp;&nbsp;{{item.title}}</span></div>
              <img v-bind:class="{arrowsimg: wapOpenArr.indexOf(item.instanceId) === -1}"
                   @click="addClassFun(index),clickAircle(item)"
                   src="../assets/close.png" alt=""/>
              <img v-bind:class="{arrowsimg: wapOpenArr.indexOf(item.instanceId) !== -1}"
                   @click="addClassFun(index),clickAircle(item)"
                   src="../assets/open.png" alt=""/>
              <div class="clear"></div>
              <webinar-details :item-info="item" v-if="wapOpenArr.indexOf(item.instanceId) !== -1" class="detailshow"/>

            </li>
          </ul>
          <el-pagination
              prev-text="上一页"
              next-text="下一页"
              background
              :current-page.sync="currentPage2"
              :page-size="pageSize"
              :total="foreShow2.length"
              layout=" prev, pager, next"
              style="text-align:center;"
              @current-change="handleCurrentChange2"
          />
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import WebinarDetails from './WebinarDetails';
  import moment from 'moment';
  import Login from './Login';
  import Register from './Register';
  import {getCookie} from '../utils/public';
  import bus from '../utils/eventBus';
  import url from '../utils/url'

  export default {
    name: 'WebinarList',
    data: function () {
      return {
        foreShow1: [],
        foreShow2: [],
        currentYear: 2020,
        current2018: 0,  //标识
        current2019: 0,
        current2020: 0,
        radiocurrent2018: -1,
        radiocurrent2019: -1,
        radiocurrent2020: -1,
        oldsum: 0,
        newsum: 0,
        selectSum: 0,
        dataList: [],   //直播数据
        dataEndList: [], //点播数据
        start: 0, // 当前页码
        pageSize: 10, // 页面大小
        currentPage1: 1,  //  直播当前页数
        currentPage2: 1,  //  点播当前页数
        wapOpenArr: [],  //WAP端打开的相应的数据集合
        webinargroup: '',   //正式 :基础教育计划
        currentWebinar: {},
        categoriesKee: [{
          name: '类型',
          active: false,
          children: [{
            name: '全部',
            active: false,
            c: 'isForeshow'
          }, {
            name: '课程预告',
            active: false,
            c: 'isForeshow'
          }, {
            name: '课程回放',
            active: false,
            c: 'isForeshow'
          }]
        }, {
          name: '课程主题',
          active: false,
          children: [{
            name: '全部',
            active: false,
            c: 'industryType'
          }, {
            name: '测量基础知识',
            active: false,
            c: 'industryType'
          }, {
            name: '物联网',
            active: false,
            c: 'industryType'
          }, {
            name: '射频微波',
            active: false,
            c: 'industryType'
          }, {
            name: '高速数字系统测试',
            active: false,
            c: 'industryType'
          }, {
            name: '数据中心.云',
            active: false,
            c: 'industryType'
          }, {
            name: '设计与自动化',
            active: false,
            c: 'industryType'
          }, {
            name: '网络安全与可视性',
            active: false,
            c: 'industryType'
          }, {
            name: '汽车与能源',
            active: false,
            c: 'industryType'
          }, {
            name: '5G与无线',
            active: false,
            c: 'industryType'
          },{
              name: '集成电路/半导体和制造',
              active: false,
              c: 'industryType'
          },{
              name: '教育',
              active: false,
              c: 'industryType'
          },{
              name: '蜂窝通信',
              active: false,
              c: 'industryType'
          },
          ]
        }, {
          name: '时间',
          active: false,
          children: [{
            name: '全部',
            active: false,
            c: 'year'
          }, {
                name: '2021',
                active: false,
                c: 'year'
           },{
            name: '2020',
            active: false,
            c: 'year'
          }, {
            name: '2019',
            active: false,
            c: 'year'
          }, {
            name: '2018',
            active: false,
            c: 'year'
          }]
        }],
        categoriesKts: [{
          name: '类型',
          active: false,
          children: [{
            name: '全部',
            active: false,
            c: 'isForeshow'
          }, {
            name: '课程预告',
            active: false,
            c: 'isForeshow'
          }, {
            name: '课程回放',
            active: false,
            c: 'isForeshow'
          }]
        }, {
          name: '课程主题',
          active: false,
          children: [{
            name: '全部',
            active: false,
            c: 'industryType'
          }, {
            name: '物联网',
            active: false,
            c: 'industryType'
          }, {
            name: '射频微波',
            active: false,
            c: 'industryType'
          }, {
            name: '高速数字系统测试',
            active: false,
            c: 'industryType'
          }, {
            name: '数据中心.云',
            active: false,
            c: 'industryType'
          }, {
            name: '设计与自动化',
            active: false,
            c: 'industryType'
          }, {
            name: '网络安全与可视性',
            active: false,
            c: 'industryType'
          }, {
            name: '汽车与能源',
            active: false,
            c: 'industryType'
          }, {
            name: '5G与无线',
            active: false,
            c: 'industryType'
          },{
              name: '集成电路/半导体和制造',
              active: false,
              c: 'industryType'
          },{
              name: '教育',
              active: false,
              c: 'industryType'
          },{
              name: '蜂窝通信',
              active: false,
              c: 'industryType'
          },]
        }, {
          name: '时间',
          active: false,
          children: [{
            name: '全部',
            active: false,
            c: 'year'
          },{
                name: '2021',
                active: false,
                c: 'year'
           }, {
            name: '2020',
            active: false,
            c: 'year'
          }]
        }],
        categories: [],
        query: {
          pageSize: '10',
          start1: 0,
          start2: 0,
          conditions: [],
        },
        industryType: [], // 选中的课程主题
        showType: [],  //  直播类型
        year: [], //  年份条件
        webinarShow: true,  //  直播显示
        demindShow: true,   //  点播显示
        curIndex: "0",   //切换栏当前索引值
        typeId: "1001",  //选择类型id
        followerId: "1001",  //子id
        isUrlParam: true,  // 是否是从url取的参数
        checkedAll: false,  //是否全选
        keePhase: '',  //筛选条件，第几期，还是第几讲
      };
    },
    components: {
      WebinarDetails,
      Login,
      Register
    },
    created: function () {//生命周期钩子函数
      this.industryType = url.GetQueryString('industryType') ? url.GetQueryString('industryType').split(",") : [];
      this.showType = url.GetQueryString('showType') ? url.GetQueryString('showType').split(",") : [];
      this.year = url.GetQueryString('year') ? url.GetQueryString('year').split(",") : [];
      this.categories = this.type === 'KEE'? this.categoriesKee: this.categoriesKts;
      this.webinargroup = this.type === 'KEE'?'基础教育计划':'KTS';
      this.keePhase = this.type === 'KEE'?'第%期':'第%讲';

      this.getList()
    },
    computed: {
      isWap() {
        return $(document).width() <= 750;
      },
      instanceId() {
        return this.$store.state.instanceId;
      },
      LoginStatus() {
        return this.$store.state.loginStatus;
      },
      userInfo() {
        return this.$store.state.info;
      },
      type(){
        return this.$store.state.type;
      },
      //  直播分页处理数据
      afterChangeData1() {
        let self = this;
        let start = (this.currentPage1 - 1) * this.pageSize;
        let end = this.currentPage1 * this.pageSize;
        if (this.industryType.length != 0 && this.isUrlParam) {
          self.categories.forEach((item, index) => {
            if (item.name == '课程主题' && this.industryType.length != 0) {
              item.active = true;
              item.children.forEach(child => {
                this.industryType.forEach(item1 => {
                  if (item1 == child.name) {
                    child.active = true;
                  }
                })
              })
            }
            if(item.name == '类型' && this.showType.length != 0){
              item.active = true;
              item.children.forEach(child => {
                this.showType.forEach(item1 => {
                  if (item1 == child.name) {
                    child.active = true;
                  }
                })
              })
            }
            if(item.name == '时间' && this.year.length != 0){
              item.active = true;
              item.children.forEach(child => {
                this.year.forEach(item1 => {
                  if (item1 == child.name) {
                    child.active = true;
                  }
                })
              })
            }
            if (item.active && self.query.conditions.indexOf(item) <= -1) {
              self.query.conditions.push(item);
            }
          });
          this.isUrlParam = false;
          console.log('isUrlParam')
        }

        // 课程预告  和 课程回放显示与否
        if (this.showType.length != 0) {
          if (this.showType.length == 2) {
            this.webinarShow = true;
            this.demindShow = true;
          } else {
            if (this.showType[0] == '课程预告') {
              this.webinarShow = true;
              this.demindShow = false;
            } else {
              this.webinarShow = false;
              this.demindShow = true;
            }
          }
        } else {
          this.webinarShow = true;
          this.demindShow = true;
        }

        this.handleWebinarData(this.dataList, 'foreShow1', 1);
        this.handleWebinarData(this.dataEndList, 'foreShow2', 2);
        let currentArr = this.foreShow1.slice(start, end);
        this.$store.commit('setUrlParam', {industryType:this.industryType.join(','),year:this.year.join(','),showType: this.showType.join(',')});
        console.log(currentArr)
        return currentArr
      },
      //  点播分页处理数据
      afterChangeData2() {
        let start = (this.currentPage2 - 1) * this.pageSize;
        let end = this.currentPage2 * this.pageSize;

        let currentArr = this.foreShow2.slice(start, end);
        // this.$store.commit('setUrlParam', {industryType:this.industryType,year:this.year,showType: this.showType});
        console.log(currentArr)
        return this.foreShow2.slice(start, end)
      },

    },
    watch: {
      newsum(val) {
        if (val === this.oldsum && this.oldsum !== 0) {
          this.oldsum = 0;
          this.newsum = 0;
          bus.$emit('showToast', '报名成功');
        }
      },
      LoginStatus(val) {  //普通的watch监听
        if (val === 1) {
          this.getAttendList();
        }
      },
      type(val){
        this.$store.commit('setIsLoading', 'show');
        this.webinargroup = this.type === 'KEE'?'基础教育计划':'KTS';
        this.categories = this.type === 'KEE'? this.categoriesKee: this.categoriesKts;
        this.keePhase = this.type === 'KEE'?'第%期':'第%讲';
        this.industryType= []; // 选中的课程主题
        this.showType= [];  //  直播类型
        this.year= []; //  年份条件
        this.current2020 = 0;
        this.getList();
      },

      // query: {
      //   deep:true,
      //   handler(val,oldVal) {
      //     let industryType = [],year = [],showType = [];
      //     val.conditions.filter(item => {
      //       if(item.c === 'industryType') {
      //         if(item.name !== '全部') {
      //           industryType.push(item.name)
      //         }else {
      //           industryType.push('测量基础知识','物联网','射频微波','高速数字系统测试','数据中心云','设计与自动化','网络安全与可视性','汽车与能源','5G/无线');
      //         }
      //       }
      //       if(item.c === 'isForeshow') {
      //         if(item.name !== '全部') {
      //           showType.push(item.name)
      //         }else{
      //           showType.push('课程预告','课程回放')
      //         }
      //       }
      //       if(item.c === 'year') {
      //         if(item.name !== '全部'){
      //           year.push(item.name)
      //         } else {
      //           year.push('2018','2019','2020')
      //         }
      //       }
      //     })
      //     industryType = [...new Set(industryType)];
      //     showType = [...new Set(showType)];
      //     year = [...new Set(year)]
      //     //console.log(industryType,showType,year)
      //     //console.log(this.isForeshow1,this.isForeshow2)
      //     var aa = this.isForeshow2.filter(item => {
      //       return year.indexOf(item.yeardata) >= 0;
      //     })
      //     console.log(aa);
      //   }
      // }
    },
    methods: {
      //  根据对象属性，数组去重方法
      arrFun(Arr, key) {
        var hash = {};
        return Arr = Arr.reduce(function (arr, current) {
          hash[current[key]] ? '' : hash[current[key]] = true && arr.push(current);
          return arr
        }, [])
      },
      getList: function () {    //获取全部数据
        let self = this;
        let listdata = [];
        let listenddata = [];
        let msg_webinar = {    //直播列表所需要的数据
          'tenantId': smarket.Config('tenantId'),
          'startDate': '',
          'status': 3,      //1-待发布, 2-审核中, 3-已发布, 4-已结束, 99-垃圾箱
          'keyword': '',
          'orderBy': 'startTime',
          'fieldsDisplay': ['webinargroup', 'keePhase', 'industryType','ktsImg'],
          'fieldsCondition': [
            {
              'fieldName': 'webinargroup',
              'fieldComparison': '=',
              'fieldValue': self.webinargroup,
              'includeNull': 0
            },
            {
              'fieldName': 'keePhase',
              'fieldComparison': 'like',
              'fieldValue': self.keePhase,
              'includeNull': 0
            }
          ],
          'videoType': '1'
        };
        let msg_end_webinar = {   //直播已结束的列表所需要的数据
          'tenantId': smarket.Config('tenantId'),
          'startDate': '',
          'status': 4,
          'keyword': '',
          'orderBy': 'startTime',
          'fieldsDisplay': ['webinargroup', 'keePhase', 'industryType','ktsImg'],
          'fieldsCondition': [
            {
              'fieldName': 'webinargroup',
              'fieldComparison': '=',
              'fieldValue': self.webinargroup,
              'includeNull': 0
            }
          ],
          'videoType': '1'
        };

        return $.when($.ajax({//获取直播会议列表 接口
          url: window.config.api.gateway.general + '/webinar/open/getWebinarListAdvanced',
          type: 'post',
          dataType: 'json',
          data: msg_webinar
        }).then(function (data) {
          self.dataList = data.body.content.items ?data.body.content.items: [];
        }), $.ajax({//获取已结束的直播会议列表
          url: window.config.api.gateway.general + '/webinar/open/getWebinarListAdvanced',
          type: 'post',
          dataType: 'json',
          data: msg_end_webinar
        }).then(function (data) {
          self.dataEndList = data.body.content.items?data.body.content.items:[];
        })).then(function () {
          self.$nextTick(() => {
            //self.dataListAll = listdata.concat(listenddata);   //合并两个数组
            if (self.dataEndList.length !== 0) {
              self.YearDataList(self.dataEndList);
              self.$store.commit('setIsLoading', 'hide');
            }
            if (self.dataList.length !== 0) {
              self.YearDataList(self.dataList);
              self.$store.commit('setIsLoading', 'hide');
            }
          });
        });
      },

      YearDataList: function (data) {    //将数据整理按年份划分
        let self = this;
        self.wapOpenArr = [];
        $.each(data, function (index, item) {
          self.$set(item, 'newStartTime', moment.unix(item.startTime).format('YYYY-MM-DD'));   //时间戳转换为日期
          self.$set(item, 'yeardata', 0); //判断为2018年，还是2019年数据
          item.isForeshow = 0; //类型（0为预告，1为回放）
          self.$set(item, 'Todynum', 0);   //判断当前会议状态（0为未直播，1为今日直播，2为正在直播，3为直播结束）
          self.$set(item, 'selectedStatus', false);   //判断是否为已报名
          item.subselected = false;  //选择状态（false为未选中，ture为已选中）
          self.LiveToday(item);   //判断会议是否为今日直播
          self.$set(item, 'keePhase', item.itemValues[1]);
          let Year = item.newStartTime.substring(0, 4);   //截取年数
          if (Year === '2019') {
            item.yeardata = 2019;
          } else if (Year === '2018') {
            item.yeardata = 2018;
          } else if (Year === '2020') {
            item.yeardata = 2020;
          }else if (Year === '2021') {
              item.yeardata = 2021;
          }
          item.industryType = item.itemValues[0].value.split(',');
          self.IsEndTime(item);  //判断2018、2019年的哪些为預告些数据为回放
        });
        self.getAttendList();
        self.$nextTick(() => {     //列表的省略号
          let listsortArr = this.dataList.filter(function (item) {
            return item.isForeshow === 1;
          });
          listsortArr.sort(function (a, b) {
            return b.newStartTime < a.newStartTime ? 1 : -1;
          });
          self.foreShow1 = listsortArr;
          let listsortArr1 = this.dataEndList.filter(function (item) {
            return item.isForeshow === 2;
          });
          listsortArr1.sort(function (a, b) {
            return b.newStartTime > a.newStartTime ? 1 : -1;
          });
          self.foreShow2 = listsortArr1;
          this.handleCurrentChange2(this.currentPage2);
          if (self.foreShow1.length !== 0) {
            self.vuexdata(self.foreShow1[0]);  //默认显示2020年预告中的第一条数据详情
            //self.wapOpenArr.push(self.sort2019[0].instanceId);  //wap默认显示2019年预告中的第一条数据详情
          } else if (self.foreShow2.length !== 0) {
            self.vuexdata(self.foreShow2[0]);  //默认显示2019年预告中的第一条数据详情
            //self.wapOpenArr.push(self.sortEnd2019[0].instanceId);
          }
          $('.traildot').dotdotdot({
            ellipsis: '\u2026 ',
            truncate: 'letter',
            keep: '.todydots',
            watch: true
          });
        });
      },

      vuexdata: function (data) {   //vuex传值
        this.currentWebinar = data;
        this.$store.commit('getinstanceId', data.instanceId);
        this.$store.commit('getselectedStatus', data.selectedStatus);
        this.$store.commit('getisForeshow', data.isForeshow);
        this.$store.commit('getTodynum', data.Todynum);
      },

      switchYear: function (year) {   //点击2018、2019的切换，并默认显示每一年的第一条内容
        this.wapOpenArr = [];
        this.currentYear = year;
        if (year === 2018) {
          if (this.sort2018.length !== 0) {
            this.current2018 = 0;
            this.radiocurrent2018 = -1;
            this.vuexdata(this.sort2018[0]);
            //this.wapOpenArr.push(this.sort2018[0].instanceId);
          } else {
            this.current2018 = -1;
            this.radiocurrent2018 = 0;
            this.vuexdata(this.sortEnd2018[0]);
            //this.wapOpenArr.push(this.sortEnd2018[0].instanceId);
          }
        } else if (year === 2019) {
          if (this.sort2019.length !== 0) {
            this.current2019 = 0;
            this.radiocurrent2019 = -1;
            this.vuexdata(this.sort2019[0]);
            //this.wapOpenArr.push(this.sort2019[0].instanceId);
          } else {
            this.current2019 = -1;
            this.radiocurrent2019 = 0;
            this.vuexdata(this.sortEnd2019[0]);
            //this.wapOpenArr.push(this.sortEnd2019[0].instanceId);
          }
        } else if (year === 2020) {
          if (this.sort2020.length !== 0) {
            this.current2020 = 0;
            this.radiocurrent2020 = -1;
            this.vuexdata(this.sort2020[0]);
            //this.wapOpenArr.push(this.sort2019[0].instanceId);
          } else {
            this.current2020 = -1;
            this.radiocurrent2020 = 0;
            this.vuexdata(this.sortEnd2020[0]);
            //this.wapOpenArr.push(this.sortEnd2019[0].instanceId);
          }
        }
        this.$nextTick(() => {
          $('.traildot').dotdotdot({
            ellipsis: '\u2026 ',
            truncate: 'letter',
            keep: '.todyradio .todyradio2',
            watch: true
          });
        });
      },

      addClassFun: function (index) {
        if (this.currentYear === 2018) {
          this.current2018 = index;
          this.current2019 = 0;
          this.current2020 = 0;
        } else if (this.currentY === 2019) {
          this.current2019 = index;
          this.current2018 = 0;
          this.current2020 = 0;
        } else {
          this.current2020 = index;
          this.current2018 = 0;
          this.current2019 = 0;
        }
        this.radiocurrent2018 = -1;
        this.radiocurrent2019 = -1;
        this.radiocurrent2020 = -1;
      },

      addaudioClas: function (index) {
        if (this.currentYear === 2018) {
          this.radiocurrent2018 = index;
          this.radiocurrent2019 = -1;
          this.radiocurrent2020 = -1;
        } else if (this.currentYear === 2019) {
          this.radiocurrent2019 = index;
          this.radiocurrent2018 = -1;
          this.radiocurrent2020 = -1;
        } else {
          this.radiocurrent2019 = -1;
          this.radiocurrent2018 = -1;
          this.radiocurrent2020 = index;
        }
        this.current2018 = -1;
        this.current2019 = -1;
        this.current2020 = -1;
      },

      clickAircle: function (data) {     //点击存储相对应的instanceId
        let self = this;
        self.vuexdata(data);
        let index = self.wapOpenArr.indexOf(data.instanceId);   //获取点击的ID是否存在于数组中的下标
        if (index === -1) {
          self.wapOpenArr.push(data.instanceId);   //不存在的话，追加到数组中
        } else {
          self.wapOpenArr.splice(index, 1);    //存在的话，删除该ID
        }
      },

      getAttendList: function () {    // 获取已报名的会议列表
        let self = this;
        if (self.LoginStatus === 1) {
          $.each(self.dataList, function(i, item) {
            item.selectedStatus = false;
          });
          $.ajax({
            url: window.config.api.gateway.general + '/webinar/open/getAttendList',
            type: 'post',
            dataType: 'json',
            data: {
              'tenantId': smarket.Config('tenantId'),
              'start': 0,
              'videoType': '1',
              'includeExtends': '1',
              'includeGuest': '0',
              'orderBy': 'createTime',
              'sort': 'desc',
              'sess': getCookie('sess')
            }
          }).then((data) => {
            if (data.body.content.items) {
              let signList = data.body.content.items;
              $.each(signList, function(index, items) {
                $.each(self.dataList, function(i, item) {     //判断全部会议哪些为已报名的
                  if (items.webinarId === item.webinarId) {
                    item.selectedStatus = true;
                  }
                });
              });
              let listsortArr = this.dataList.filter(function (item) {
                  return item.isForeshow === 1;
              });
              listsortArr.sort(function (a, b) {
                  return b.newStartTime < a.newStartTime ? 1 : -1;
              });
              self.foreShow1 = listsortArr;
              //   debugger
              self.vuexdata(self.currentWebinar);
            }
          });
        }
      },

      IsEndTime: function (item) {  //判断结束时间是否超过72小时,超过72小时的为回放，小于71小时的为預告
        let date = moment().valueOf();   //parse() 方法可解析一个日期时间字符串，并返回 1970/1/1 午夜距离该日期时间的毫秒数。
        let time = 72 * 60 * 60 * 1000;  //将72小时转换为时间戳
        let endTime = moment.unix(item.endTime).valueOf();  //转换为时间戳
        if (date - endTime <= time) {  //如果当天时间的0点 减去 已结束的会议的结束时间 不大于72小时
          item.isForeshow = 1;
        } else {
          item.isForeshow = 2;
        }
      },

      /**
       * 判断是否为今日直播
       * @param item 单场会
       * @constructor
       */
      LiveToday: function (item) {
        let Todytime = moment(item.startTime * 1000).format('YYYY-MM-DD');   //会议当天日期
        let _itemStart00 = moment(Todytime + ' 00:00:00').unix();
        let _itemStartTime = moment(Todytime + ' 14:30:00').unix();
        let _itemEndTime = this.type === 'KEE'?moment(Todytime + ' 17:30:00').unix():moment(Todytime + ' 16:30:00').unix();
        let now = moment().unix(); // 当前时间
        if (now < _itemStart00) {
          //未开始 当前时间小于会议当天开始
          item.Todynum = 0;
        } else if (now > _itemStart00 && now < _itemStartTime) {
          //今日直播 当前时间大于会议当天开始 && 当前时间小于会议开始时间
          item.Todynum = 1;
        } else if (now > _itemStartTime && now < _itemEndTime) {
          //正在直播 当前时间大于会议开始时间 && 当前时间小于会议结束时间
          item.Todynum = 2;
        } else if (now > _itemEndTime) {
          //已结束 当前时间大于会议结束时间 && 会议结束时间小于今天24点
          item.Todynum = 3;
        }
      },

      subselect: function (item) {        //点击判断会议是否是要报名的会议
        if (!item.subselected) {
          this.selectSum = this.selectSum + 1;
        } else {
          this.selectSum = this.selectSum - 1;
        }
        item.subselected = !item.subselected;
      },

      submitAll: function () {   //全选按钮点击 选择全部会议
        let self = this;
        self.checkedAll = !self.checkedAll;
        self.foreShow1.forEach(item => {
          item.subselected = self.checkedAll;
        });
        this.handleWebinarData(this.dataList,'foreShow1',1);
      },

      submitFun: function () {   //点击线上会报名表单提交
        let self = this;
        if (self.LoginStatus === 1) {
          $.each(self.dataList, function(index, item) {
            if (item.subselected && !item.selectedStatus) {
              self.oldsum = self.oldsum + 1;
              self.submitData(item);
            }
          });
          if (self.oldsum === 0) {
            bus.$emit('showToast', '请勾选您想要报名的课程');   //提示框
          }
        } else {
          bus.$emit('showToast', '想要报名课程，请先“注册”或“登录”');
        }
      },

      submitData: function (item) {  //报名接口
        let self = this;
        console.log('this.userInfo',this.userInfo)
        $.ajax({
          url: window.config.api.gateway.general + '/customForm/action',
          type: 'post',
          dataType: 'json',
          data: {
            instanceId: item.instanceId,
            customFormId: item.customFormId,
            globalUserId: getCookie('globalUserId'),
            sess: getCookie('sess'),
            name: this.userInfo.name,
            memberId: this.userInfo.memberId,
            items: [
              {
                fieldName: 'name',
                value: this.userInfo.name
              }, {
                fieldName: 'mobile',
                value: this.userInfo.mobile || this.userInfo.InternationalMobile
              }, {
                fieldName: 'email',
                value: this.userInfo.emailNew || this.userInfo.email
              }, {
                fieldName: 'company',
                value: this.userInfo.company ? this.userInfo.company : ''
              }, {
                fieldName: 'addr',
                value: this.userInfo.addr
              }, {
                fieldName: 'firstName',
                value: this.userInfo.firstName
              }, {
                fieldName: 'lastName',
                value: this.userInfo.lastName
              }, {
                fieldName: 'm_qudao',
                value: $.cookie('ARC') || ''
              }, {
                fieldName: 'f_5053',
                value: this.userInfo.f_5053[0]
              }, {
                fieldName: 'zhiwei',
                value: this.userInfo.zhiwei ? this.userInfo.zhiwei[0] : ''
              }, {
                fieldName: 'country',
                value: this.userInfo.country
              }, {
                fieldName: 'city',
                value: this.userInfo.city
              }, {
                fieldName: 'address',
                value: this.userInfo.address
              }, {
                fieldName: 'dAddress',
                value: this.userInfo.dAddress
              }, {
                fieldName: 'postCode',
                value: this.userInfo.postCode
              }, {
                fieldName: 'province',
                value: this.userInfo.province?this.userInfo.province[0]:''
              }
            ],
            url: window.location.href,
            referenceUrl: window.location.href,
            ver: 'v2.0.1',
            linkId: 1
          },
          success: function (data) {
            if (data.body.result === 0) {
              item.selectedStatus = true;
              item.subselected = false;
              self.newsum = self.newsum + 1;
              self.selectSum = self.selectSum - 1;
              self.vuexdata(self.currentWebinar);
            }
          }
        });
      },

      //  处理直播/点播数据
      handleWebinarData(sourceData, showArr, isForeshow) {   // (isForeshow: 1 直播  ，2 点播)
        var self = this;
        // 处理直播数据
        const newArrs = [];
        let listsortArr = sourceData.filter(function (item) {
          return item.isForeshow === isForeshow;
        });

        if (this.industryType.length != 0 && this.year.length == 0) {  // 课程主题
          this.industryType.forEach(item => {
            listsortArr.forEach(item1 => {
              item1.industryType.forEach(item2 => {
                if (item == item2) {
                  newArrs.push(item1)
                }
              })
            })
          });
          let twoTypeArr = this.arrFun(newArrs, 'id');
          twoTypeArr.sort(function (a, b) {
            if (isForeshow == 1) {
              return b.newStartTime < a.newStartTime ? 1 : -1;
            }
            if (isForeshow == 2) {
              return b.newStartTime > a.newStartTime ? 1 : -1;
            }
          });
          self[showArr] = twoTypeArr;
        } else if (this.year.length != 0 && this.industryType.length == 0) {  //  年份
          this.year.forEach(item => {
            listsortArr.forEach(item1 => {
              if (item == item1.yeardata) {
                newArrs.push(item1)
              }
            })
          });
          let twoTypeArr = this.arrFun(newArrs, 'id');
          twoTypeArr.sort(function (a, b) {
            if (isForeshow == 1) {
              return b.newStartTime < a.newStartTime ? 1 : -1;
            }
            if (isForeshow == 2) {
              return b.newStartTime > a.newStartTime ? 1 : -1;
            }
          });
          self[showArr] = twoTypeArr;
        } else if (this.year.length != 0 && this.industryType.length != 0) {   //  课程主题和年份同事存在的条件
          let twoTypeArr = [];
          this.year.forEach(item => {
            listsortArr.forEach(item1 => {
              if (item == item1.yeardata) {
                newArrs.push(item1)
              }
            })
          });
          this.industryType.forEach(item => {
            newArrs.forEach(item1 => {
              item1.industryType.forEach(item2 => {
                if (item == item2) {
                  twoTypeArr.push(item1)
                }
              })
            })
          });
          twoTypeArr = this.arrFun(twoTypeArr, 'id');
          twoTypeArr.sort(function (a, b) {
            if (isForeshow == 1) {
              return b.newStartTime < a.newStartTime ? 1 : -1;
            }
            if (isForeshow == 2) {
              return b.newStartTime > a.newStartTime ? 1 : -1;
            }
          });
          self[showArr] = twoTypeArr;
        } else {
          listsortArr.sort(function (a, b) {
            if (isForeshow == 1) {
              return b.newStartTime < a.newStartTime ? 1 : -1;
            }
            if (isForeshow == 2) {
              return b.newStartTime > a.newStartTime ? 1 : -1;
            }
          });
          self[showArr] = listsortArr;
        }
      },

      handleCategory1: function (index, key, childName) {
        var self = this;
        var item = this.categories[index].children;
        var subItem = item.slice(1);
        console.log(subItem)
        item.filter(function (v, i) {
          if (i == key) {
            v.active = !v.active;
            // if((i==0) && (v.active == true)) {
            //   var selectedIndex = subItem.some(si => {
            //     return si.active == true
            //   })
            //   console.log(selectedIndex,'111111')
            //   // v.active = selectedIndex ? false:true;
            // }
            // if((i!=0) && (v.active == true)){
            //   item[0].active =false;
            // }
          }

          if (v.active && self.query.conditions.indexOf(v) <= -1) {
            self.query.conditions.push(v);
          }
        });

        this.query.conditions.filter(function (v, i) {
          if (!v.active) {
            self.query.conditions.splice(i, 1);
          }
        });
        let industryType = [], year = [], showType = [];
        this.query.conditions.filter(item => {
          if (item.c === 'industryType') {
            if (item.name !== '全部') {
              industryType.push(item.name)
            } else {
              industryType.push('测量基础知识', '物联网', '射频微波', '高速数字系统测试', '数据中心.云', '设计与自动化', '网络安全与可视性', '汽车与能源', '5G与无线');
            }
          }
          if (item.c === 'isForeshow') {
            if (item.name !== '全部') {
              showType.push(item.name)
            } else {
              showType.push('课程预告', '课程回放')
            }
          }
          if (item.c === 'year') {
            if (item.name !== '全部') {
              year.push(item.name)
            } else {
              year.push('2018', '2019', '2020')
            }
          }
        })
        industryType = [...new Set(industryType)];
        showType = [...new Set(showType)];
        year = [...new Set(year)]
        if(this.categories[index].name == '类型'){
          this.showType = showType;
        }
        if(this.categories[index].name == '课程主题'){
          this.industryType = industryType;
        }
        if(this.categories[index].name == '时间'){
          this.year = year;
        }

        // this.industryType = industryType;
        // this.showType = showType;
        // this.year = year;
        console.log('showType', this.showType)
        console.log('year', this.year)


      },
      handleCategory: function (index, key, childName) {
        var self = this;
        var item = this.categories[index].children;
        item.forEach(item => {
          if(childName == '全部'){
            if(item.name != '全部'){
              item.active = false;
            }else{
              item.active = !item.active;
            }
          }else{
            if(item.name == childName){
              item.active = !item.active;
            }
            if(item.name == '全部'){
              item.active = false;
            }
          }
          if (item.active && self.query.conditions.indexOf(item) <= -1) {
            self.query.conditions.push(item);
          }
        })
        // if(childName == '全部'){
        //   item.forEach(item => {
        //     if(item.name != '全部'){
        //       item.active = false;
        //     }else{
        //       item.active = !item.active;
        //     }
        //     if (item.active && self.query.conditions.indexOf(item) <= -1) {
        //       self.query.conditions.push(item);
        //     }
        //   })
        // }else{
        //   item.forEach(item => {
        //     if(item.name == childName){
        //       item.active = !item.active;
        //     }
        //     if(item.name == '全部'){
        //       item.active = false;
        //     }
        //     if (item.active && self.query.conditions.indexOf(item) <= -1) {
        //       self.query.conditions.push(item);
        //     }
        //   })
        // }

        this.query.conditions.filter(function (v, i) {
          if (!v.active) {
            self.query.conditions.splice(i, 1);
          }
        });
        let industryType = [], year = [], showType = [];
        this.query.conditions.filter(item => {
          if (item.c === 'industryType') {
            if (item.name !== '全部') {
              industryType.push(item.name)
            } else {
              industryType.push('测量基础知识', '物联网', '射频微波', '高速数字系统测试', '数据中心.云', '设计与自动化', '网络安全与可视性', '汽车与能源', '5G与无线','集成电路/半导体和制造','教育','蜂窝通信');
            }
          }
          if (item.c === 'isForeshow') {
            if (item.name !== '全部') {
              showType.push(item.name)
            } else {
              showType.push('课程预告', '课程回放')
            }
          }
          if (item.c === 'year') {
            if (item.name !== '全部') {
              year.push(item.name)
            } else {
              year.push('2018', '2019', '2020','2021')
            }
          }
        })
        industryType = [...new Set(industryType)];
        showType = [...new Set(showType)];
        year = [...new Set(year)]
        if(this.categories[index].name == '类型'){
          this.showType = showType;
        }
        if(this.categories[index].name == '课程主题'){
          this.industryType = industryType;
        }
        if(this.categories[index].name == '时间'){
          this.year = year;
        }

        // this.industryType = industryType;
        // this.showType = showType;
        // this.year = year;
        console.log('showType', this.showType)
        console.log('year', this.year)


      },

      handleCurrentChange: function (val) {
        this.currentPage1 = val;
      },
      handleCurrentChange2: function (val) {
        this.currentPage2 = val;
        // let start = (this.currentPage2 - 1) * this.pageSize;
        // let end = this.currentPage2 * this.pageSize;
        // let currentArr = this.foreShow2.slice(start, end);
        // console.log('start',start)
        // console.log('end',end)
        // console.log(currentArr)
        // this.realArr = this.foreShow2.slice(start, end);
        // return this.foreShow2.slice(start, end)
      },
      changeTab: function (index) {
        var self = this;
        this.curIndex = index;
        this.categories.forEach(function (v, i) {
          self.$set(v, 'active', false);
          if (index !== i) {
            self.$set(v, 'isShow', false);
          }
        })
        this.categories[index].active = true;
        this.categories[index].isShow = !this.categories[index].isShow;
      },
      chooseItem: function () {
        console.log('111')
      }
    }
  };
</script>

<style scoped lang="scss">
    .webinarCon /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        color: #ec001f;
        background-color: #fdfdfd;
        border: 1px solid #f4f4f5;
    }

    .webinarCon /deep/ .el-pagination.is-background .btn-next, /deep/ .el-pagination.is-background .btn-prev, /deep/ .el-pagination.is-background .el-pager li {
        padding: 0 10px;
        background-color: #fdfdfd;
        border: 1px solid #f4f4f5;
    }

    .webinarCon /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #ec001f;
    }

    .pc {
        display: block;
    }

    .Wap {
        display: none;
        width: pxToRem(750);
    }

    .clear {
        clear: both;
    }

    #webinarList {
        flex: 0 0 54%;
    }

    .description {
        margin-left: 3px;
        margin-right: 18px;

        &__title {
            position: relative;
            font-size: 24px;
            line-height: 1em;
            color: #524f56;
            padding-left: 16px;
            margin: 22px 0 10px;

            &:before {
                content: '';
                display: block;
                width: 5px;
                height: 20px;
                background-color: #e90029;
                position: absolute;
                left: 0;
                top: 2px;
            }
        }

        &__content {
            color: #777;
            font-size: 13px;
            line-height: 21px;

            .primary {
                font-weight: bold;
                color: #524f56;
                font-size: 15px;
                line-height: 31px;
            }
          img{
            width: 100%;
          }
          .label{
            background: url("../assets/kts/icon-titlelabel.png") no-repeat left top 6px;
            background-size: 7px 8px;
            padding-left: 20px;
            margin-top: 10px;
          }
        }
    }

    %line {
        content: '';
        display: block;
        width: 100%;
        height: 3px;
        background-color: #f0f0f0;
        position: absolute;
        bottom: 0;
        z-index: 1;
    }

  .tabBar {
    margin: 0 19px 25px 1px;
    padding-top: 16px;

    position: relative;
    .nav{
      width: 100%;
      height:100%;
      display: block;
      border-bottom:1px dashed gray;
      padding-bottom:10px;
      .active{
        color:#e90029;
      }
      .mutil-query-title{
        margin-right:20px;
        float: left;
        font-size: 16px;
        font-weight: bold;
        padding: 5px;
        span{
          padding: 2px;
          cursor:pointer;
        }
      }
      .mutil-query-title-sub{
        margin-top: 5px;
      }
      ol{
        margin:0px;
        padding:0px;
        margin-left:100px;
      }
      li{
        float: left;
        list-style: none;
        margin-right: 10px;
        margin-top:10px;
        font-size:13px;
        font-weight: normal;
        border:1px solid gray;
        border-radius:3px;
        padding:0px 5px;
        span{
          cursor:pointer;
          &:hover {
            color:#e90029;
            clear:both;
          }
        }
      }
    }

        > div {
            position: relative;
            width: 160px;
            /*float: left;*/
            /*text-align: center;*/
            font-size: 24px;
            font-weight: bold;
            line-height: 1em;
            overflow: hidden;
            height: 54px;
            cursor: pointer;
            transition: color .2s ease-in-out;

            &:before {
                @extend %line;
                background-color: #e90029;
                width: 0;
                transition: width .2s ease-in-out;
            }

            > span {
                position: absolute;
                left: 0;
                bottom: 10px;
                width: 100%;
                z-index: 1;
                transition: bottom .2s ease-in-out;
            }

            > small {
                position: absolute;
                color: #a4a1a9;
                font-size: 60px;
                width: 100%;
                left: 0;
                bottom: 3px;
                text-align: center;
                opacity: 0;
                transition: opacity .2s ease-in-out;
            }

            &.active {
                font-size: 30px;
                color: #e90029;
                cursor: default;

                &:before {
                    width: 100%;
                }

                > span {
                    bottom: 12px;
                }

                > small {
                    opacity: .12;
                }
            }
        }
    }

    .webinarCon {
        position: relative;

    .submitAll {
      position: absolute;
      background-color: rgba(251, 232, 235, .4);
      color: #ec001f;
      border: 1px solid rgb(251, 232, 235);
      border-radius: 2px;
      height: 32px;
      line-height: 32px;
      font-size: 15px;
      width: 96px;
      text-align: center;
      right: 140px;
      cursor: pointer;
    }

    .signUp {
      position: absolute;
      background-color: #e90029;
      color: #f7f7f7;
      border-radius: 2px;
      height: 32px;
      line-height: 32px;
      font-size: 15px;
      width: 112px;
      text-align: center;
      right: 20px;
      cursor: pointer;
    }

        .webinarList {
            display: none;
            margin-top: 1px;

            &.active {
                display: block;
            }

            .trailNoticeCon {

                .title {
                    color: #e90029;
                    margin-left: 10px;
                    padding: 3px 0;

                    img {
                        display: block;
                        height: 19px;
                    }
                }

                .list {
                    margin-top: 15px;
                    padding: 0;

                    li {
                        overflow: hidden;
                        list-style: none;
                        font-size: 15px;
                        color: #524f56;
                        line-height: 25px;
                        padding-left: 12px;
                        min-height: 40px;
                        max-height: 80px;
                        position: relative;

                        .traildiv {
                            margin-right: 44px;
                            display: block;
                            float: left;
                            width: 92%;

                        }

                        .wap-div {
                            max-height: 80px;
                            display: block;
                            float: left;
                            padding-top: 7px;
                            padding-bottom: 7px;
                            min-height: 40px;
                            cursor: pointer;

                            span {
                                margin-right: 10px;
                            }

                            .todyradio {
                                margin: 0;
                                display: none;
                                background: url("../assets/border4-2.png") no-repeat;
                                width: 68px;
                                height: 18px;
                                font-size: 11px;
                                line-height: 16px;
                                padding-left: 15px;
                                color: #e90c29;
                                vertical-align: -4px;
                            }

                            .todyradio2 {
                                margin: 0;
                                display: none;
                                background: url("../assets/border4.png") no-repeat;
                                width: 75px;
                                height: 18px;
                                font-size: 11px;
                                line-height: 16px;
                                padding-left: 15px;
                                color: #e90c29;
                                vertical-align: -4px;
                            }

                            label {
                                margin-top: 5px;
                            }

                            .selectd {
                                background: url("../assets/checkbox-active2.png") no-repeat !important;
                            }
                        }

                        .redclass {
                            width: 89%;
                        }

                        .inputhide {
                            display: none;
                        }

                        img {
                            display: none;
                        }

                        .arrowsimg {
                            position: absolute;
                            width: 18px;
                            height: 11px;
                            right: 25px;
                            top: 15px;
                            display: block;
                        }
                    }

                    .bgactive {
                        background: #f7f7f7;
                    }

                    li:hover {
                        background: #f7f7f7;
                    }

                    .liactive {
                        color: #e90029;
                    }
                }
            }

            .playbackCon {
                margin-top: 25px;

                .title {
                    color: #e90029;
                    margin-left: 10px;
                    padding: 3px 0;

                    img {
                        display: block;
                        height: 19px;
                    }
                }

                .list {
                    margin-top: 15px;
                    padding: 0;

                    li {
                        overflow: hidden;
                        list-style: none;
                        font-size: 15px;
                        color: #524f56;
                        min-height: 40px;
                        max-height: 80px;
                        line-height: 40px;
                        padding-left: 12px;
                        position: relative;

                        .wap-div {
                            margin-right: 44px;
                            max-height: 80px;
                            min-height: 40px;
                            cursor: pointer;

                            span {
                                display: block;
                            }
                        }

                        img {
                            display: none;
                        }

                        .arrowsimg {
                            position: absolute;
                            width: 18px;
                            height: 11px;
                            right: 25px;
                            top: 15px;
                            display: block;
                        }
                    }

                    li:hover {
                        background: #f7f7f7;
                    }

                    .liactive {
                        background: #f7f7f7;
                        color: #e90029;
                    }
                }
            }
        }
    }

    input[type=checkbox] {
        display: none;
    }

    input[type=checkbox] + label {
        background: url("../assets/checkbox.png") no-repeat;
        background-size: 100% 100%;
        display: inline-block;
        width: 15px;
        height: 15px;
        margin-top: 3px;
        margin-right: 10px;
    }

    input[type=checkbox]:checked + label {
        background: url("../assets/checkbox-active.png") no-repeat;
    }

    .Hide {
        display: none;
    }

    .Block {
        display: inline-block !important;
    }

    /*WAP端*/
    @media screen and (max-width: 750px) {
        .pc {
            display: none;
        }
        .Wap {
            display: block;
            width: pxToRem(750);
        }

        .description {
            width: pxToRem(680);
            margin: pxToRem(40) pxToRem(35);

            &__title {
                font-size: pxToRem(34);
                padding-left: pxToRem(15);
                margin: 0 0 pxToRem(20) 0;

                &:before {
                    width: pxToRem(5);
                    height: pxToRem(30);
                    margin-top: pxToRem(-3);
                    background-color: #e90029;
                }
            }

            &__content {
                color: #777;
                font-size: pxToRem(20);
                line-height: pxToRem(30);

                .primary {
                    font-weight: normal;
                    color: #524f56;
                    font-size: pxToRem(24);
                    line-height: pxToRem(35);
                    margin-bottom: pxToRem(15);
                }
              .label{
                background: url("../assets/kts/icon-titlelabel.png") no-repeat left top pxToRem(10);
                background-size: pxToRem(13);
                padding-left: pxToRem(25);
                margin-top:  pxToRem(10);
                font-size: pxToRem(24);
                line-height: pxToRem(36);
              }
            }
        }

        .tabBar {
            > div {
                overflow: visible;
            }
            width: pxToRem(680);
            margin: 0 pxToRem(35) pxToRem(6);
            padding-top: pxToRem(40);

            ul, ol, li {
                list-style: none;
            }
            ul, ol {
                margin: 0;
                padding: 0;
            }
            .pick-con {
                width: 100%;
                height: .8rem;
                border-bottom: 1px solid #f0f0f0;
                position: relative;
                font-size: pxToRem(26);
                [v-cloak] {
                    display: none !important;
                }
                .tablist {
                    width: 100%;
                    height: 100%;
                    color: #524f56;
                    .sort-ol {
                        width: 100%;
                        height: 100%;
                        .tk {
                            width: 33.3333%;
                            height: pxToRem(36);
                            line-height: pxToRem(36);
                            background-color: #fff;
                            box-sizing: border-box;
                            float: left;
                            text-align: center;
                            position: relative;
                            font-weight: bold;
                            &:after {
                                width: 1px;
                                height: 50%;
                                background-color: #f0f0f0;
                                position: absolute;
                                right: 0px;
                                top: 25%;
                            }
                            &:last-of-type {
                                background-color: transparent;
                            }
                            .i {
                                width: .2rem;
                                height: .12rem;
                                background-repeat: no-repeat;
                                background-size: cover;
                                background-image: url(../assets/icon-tab.png);
                                display: inline-block;
                                vertical-align: middle;
                                margin-left: .02rem;
                                background-position: left top;
                            }
                        }
                        .cur {
                            color: #e44135;
                            .i {
                                background-position: left bottom;
                            }
                        }
                    }
                }
                .droplist {
                    width: 100%;
                    height: auto;
                    border: 1px solid #f0f0f0;
                    position: absolute;
                    top: .8rem;
                    left: 0;
                    z-index: 1;
                    .sort-ul {
                        width: 100%;
                        height: auto;
                        background-color: #f7f7f7;
                        padding-left: pxToRem(66);
                        box-sizing: border-box;
                        .tg {
                            width: 100%;
                            /*height: 1.5rem;*/
                            padding: pxToRem(25) 0;
                            /*line-height: 1.5rem;*/
                            border-bottom: 1px solid #fbfbfb;
                            color: #524f56;
                            position: relative;
                            box-sizing: border-box;
                            font-size: pxToRem(22);
                            font-weight: normal;
                            &:last-of-type {
                                border-bottom-color: transparent;
                            }
                            &:after {
                                width: .3rem;
                                height: .3rem;
                                right: .3rem;
                                background-repeat: no-repeat;
                                background-size: cover;
                                background-image: url("../assets/i-cur.png");
                                opacity: 0;
                            }
                        }
                        .cur {
                            color: #e44135;
                            &:after {
                                opacity: 1;
                            }
                        }
                    }
                }
            }

            /*> div {*/
            /*width: pxToRem(220);*/
            /*font-size: pxToRem(38);*/
            /*height: pxToRem(70);*/

            /*> span {*/
            /*bottom: 12px;*/
            /*}*/

            /*> small {*/
            /*font-size: pxToRem(89);*/
            /*}*/

            /*&.active {*/
            /*font-size: pxToRem(42);*/
            /*}*/
            /*}*/
        }
        .webinarCon {
            width: pxToRem(680);
            margin: 0 pxToRem(35);

      .submitAll {
        background-color: rgba(251, 232, 235, .4);
        color: #ec001f;
        border: 1px solid rgb(251, 232, 235);
        border-radius: pxToRem(10);
        height: pxToRem(42);
        line-height: pxToRem(38);
        font-size: pxToRem(24);
        width: pxToRem(150);
        right: pxToRem(180);
      }

      .signUp {
        background: url("../assets/wapsubmit.png") no-repeat;
        background-size: pxToRem(175) pxToRem(42);
        color: #ec001f;
        height: pxToRem(42);
        line-height: pxToRem(38);
        font-size: pxToRem(24);
        width: pxToRem(175);
        padding-left: pxToRem(15);
        right: pxToRem(-10);
      }

            .webinarList {
                display: none;
                margin-top: 1px;

                &.active {
                    display: block;
                }

                .trailNoticeCon {
                    margin-top: pxToRem(34);

                    .title {
                        color: #e90029;
                        margin-left: 0;
                        padding: pxToRem(4) 0;

                        img {
                            display: block;
                            height: pxToRem(28);
                        }
                    }

                    .list {
                        margin-top: 15px;
                        padding: 0;

                        li {
                            font-size: pxToRem(24);
                            min-height: pxToRem(30);
                            max-height: initial;
                            line-height: pxToRem(40);

                            .traildot {
                                width: 95%;
                                padding-top: pxToRem(18)
                            }

                            .detailshow {
                                width: pxToRem(680);
                                margin-left: -12px;
                            }

                            .traildiv {
                                margin-top: pxToRem(5);
                                margin-right: pxToRem(45);
                                display: block;
                                float: left;
                                width: 85% !important;
                            }

                            .wap-div {
                                max-height: pxToRem(120);
                                display: block;
                                float: left;

                                span {
                                    margin-right: 10px;
                                }

                                .todyradio {
                                    background: url("../assets/border-wap-2.png") no-repeat;
                                    background-size: 100% 100%;
                                    width: pxToRem(95);
                                    height: pxToRem(25);
                                    line-height: pxToRem(23);
                                    padding-left: pxToRem(22);
                                    vertical-align: pxToRem(-6);
                                }

                                .todyradio2 {
                                    background: url("../assets/border-wap.png") no-repeat;
                                    background-size: 100% 100%;
                                    height: pxToRem(25);
                                    width: pxToRem(106);
                                    line-height: pxToRem(23);
                                    padding-left: pxToRem(22);
                                    vertical-align: pxToRem(-6);
                                }

                                label {
                                    margin-top: 6px;
                                }

                                .selectd {
                                    background: url("../assets/checkbox-wap-active2.png") no-repeat !important;
                                    background-size: 100% 100% !important;
                                }
                            }

                            .redclass {
                                width: 89%;
                            }

                            .inputhide {
                                display: none;
                            }

                            img {
                                display: none;
                            }

                            .arrowsimg {
                                width: pxToRem(21);
                                height: pxToRem(13);
                                top: pxToRem(32);
                                right: pxToRem(15);
                            }
                        }

                        li:hover {
                            background: #f0f0f0;
                        }

                        .liactive {
                            background: #f0f0f0;
                            color: #e90029;

                            .arrowsimg {
                                width: pxToRem(21);
                                height: pxToRem(13);
                                top: pxToRem(32);
                                right: pxToRem(15);
                            }
                        }
                    }
                }

                .playbackCon {
                    margin-top: pxToRem(34);

                    .title {
                        color: #e90029;
                        margin-left: 0;
                        padding: pxToRem(4) 0;

                        img {
                            display: block;
                            height: pxToRem(28);
                        }
                    }

                    .list {
                        margin-top: 15px;
                        padding: 0;

                        li {
                            font-size: pxToRem(24);
                            min-height: pxToRem(60);
                            max-height: initial;
                            line-height: pxToRem(40);

                            .traildot {
                                width: 95%;
                                padding-top: pxToRem(18)
                            }

                            .detailshow {
                                width: pxToRem(680);
                                margin-left: -10px;
                            }

                            .traildiv {
                                margin-right: pxToRem(45);
                                display: block;
                                float: left;
                                width: 96% !important;
                            }

                            .wap-div {
                                max-height: pxToRem(240);
                                display: block;
                                float: left;
                                padding: pxToRem(20) 0;

                                span {
                                    margin-right: 10px;
                                }

                                .selectd {
                                    background: url("../assets/checkbox-wap-active2.png") no-repeat !important;
                                    background-size: 100% 100% !important;
                                }
                            }

                            .redclass {
                                width: 89%;
                            }

                            .arrowsimg {
                                width: pxToRem(21);
                                height: pxToRem(13);
                                top: pxToRem(37);
                                right: pxToRem(15);
                            }
                        }

                        li:hover {
                            background: #f0f0f0;
                        }

                        .liactive {
                            background: #f0f0f0;
                            color: #e90029;

                            .arrowsimg {
                                width: pxToRem(21);
                                height: pxToRem(13);
                                top: pxToRem(35);
                                right: pxToRem(15);
                            }
                        }
                    }
                }
            }
        }

        input[type=checkbox] {
            display: none;
        }

        input[type=checkbox] + label {
            background: url("../assets/checkbox-wap.png") no-repeat;
            background-size: 100% 100%;
            display: inline-block;
            width: pxToRem(30);
            height: pxToRem(31);
            margin-top: 3px;
            margin-right: 10px;
        }

        input[type=checkbox]:checked + label {
            background: url("../assets/checkbox-wap-active.png") no-repeat;
            background-size: 100% 100%;
        }

    }
</style>
